export default from './Carousel'


// WEBPACK FOOTER //
// ./src/components/Carousel/index.js